import { render, staticRenderFns } from "./compare-table.vue?vue&type=template&id=063d0a2a&scoped=true"
import script from "./compare-table.vue?vue&type=script&lang=js"
export * from "./compare-table.vue?vue&type=script&lang=js"
import style0 from "./compare-table.vue?vue&type=style&index=0&id=063d0a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d0a2a",
  null
  
)

export default component.exports